
// 优化防抖函数：缩短防抖时间，避免延迟过久
function cart_debounce(func, wait = 300) { // 改为 300ms，兼顾性能和及时性
    let cart_timeout;
    return function (...args) {
        clearTimeout(cart_timeout);
        cart_timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

// 核心逻辑：确保只在 DOM 完全加载后执行
function get_product_cart_item() {
    console.log(111111111111111111)
    // 优化选择器：限定在购物车抽屉内查找，避免全局干扰
    const cartContainer = document.querySelector('#Cart-Drawer') || document.querySelector('#Cart');
    if (!cartContainer) {
        console.log('cart box not found');
        return;
    }

    // 只在购物车容器内查找元素，更精准
    const product_cart_items = cartContainer.querySelectorAll('.product-cart-item');
   // console.log('找到的购物车商品项数量：', product_cart_items.length); // 调试用，可删除
   // console.log('商品项列表：', product_cart_items); // 调试用，可删除

    let pre_order_has_count = 0;
    let normal_order_has_count = 0;

    // 确保遍历所有元素
    product_cart_items.forEach(function(item) {
        const isPreOrder = item.getAttribute('data-pre-order') === 'true';
        if (isPreOrder) {
            pre_order_has_count += 1;
        } else {
            normal_order_has_count += 1;
        }
    });

   // console.log('预售商品数：', pre_order_has_count, '普通商品数：', normal_order_has_count); // 调试用，可删除

    // 禁用/启用结账按钮
    const checkoutButtons = document.querySelectorAll('[name="checkout"]');
    const dynamicCheckout = document.querySelectorAll('.cart__dynamic-checkout-buttons');
    console.log(222222222)
    console.log(pre_order_has_count)
    console.log(normal_order_has_count)
    if ((pre_order_has_count > 0 && normal_order_has_count > 0) || pre_order_has_count > 1) {
        console.log(3333333333);
        checkoutButtons.forEach(btn => btn.disabled = true);
        dynamicCheckout.forEach(el => el.classList.add('is_disable'));
    }else {
         console.log(44444444444);
        checkoutButtons.forEach(btn => btn.disabled = false);
        dynamicCheckout.forEach(el => el.classList.remove('is_disable'));
    }
}

// 防抖后的函数
const debouncedGetProductCartItem = cart_debounce(get_product_cart_item,1000);

// 关键修复：等待 DOM 完全加载后再执行
document.addEventListener('DOMContentLoaded', function() {
    // 初始检查（DOM 加载完成后）
    debouncedGetProductCartItem();

    // 监听购物车抽屉打开事件
    document.addEventListener('cart-drawer:open', function(event) {
        console.log('Cart drawer opened');
        // 延迟一小段时间，确保抽屉内元素完全渲染
        setTimeout(debouncedGetProductCartItem, 100);
    });

    // 监听购物车项变更事件
    document.addEventListener('line-item:change:end', function(event) {
        console.log('Line item changed');
        debouncedGetProductCartItem();
    });

    document.addEventListener('cart:change:remove:over', function(event) {
        console.log('Cart item removed');
        debouncedGetProductCartItem();
    });
	//监听 cart:item-added 事件
	document.addEventListener('cart:item-added', function(event) {
		console.log('Cart item added');
		debouncedGetProductCartItem();
	});
});

